import { ArrowLeft, CircleAlert } from "lucide-react";
import type { ReactNode } from "react";

export function ScreenHeader({
  title,
  onBack,
  actions,
}: {
  title: string;
  onBack?: () => void;
  actions?: ReactNode;
}) {
  return (
    <header className="sticky top-0 z-20 border-b border-[#e3e8f0] bg-white/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-2xl items-center gap-3 px-4 sm:px-6">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-[10px] text-gray-600 transition-colors hover:bg-[#f0f3f8]"
            aria-label="戻る"
          >
            <ArrowLeft size={21} />
          </button>
        )}
        <h1 className="min-w-0 flex-1 truncate text-[18px] font-extrabold tracking-[-0.2px] text-gray-900">
          {title}
        </h1>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </header>
  );
}

export function SectionCard({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <section
      className={`rounded-[20px] border border-[#e3e8f0] bg-white p-4 ${className}`}
    >
      {children}
    </section>
  );
}

export function SectionLabel({ children }: { children: ReactNode }) {
  return (
    <h2 className="mb-2 px-1 text-xs font-bold tracking-[0.02em] text-gray-500">
      {children}
    </h2>
  );
}

export function ErrorBanner({ children }: { children: ReactNode }) {
  return (
    <div
      role="alert"
      className="flex items-start gap-2.5 rounded-[14px] border border-red-100 bg-red-50 px-4 py-3 text-sm leading-6 text-red-700"
    >
      <CircleAlert size={18} className="mt-0.5 shrink-0" />
      <div className="min-w-0">{children}</div>
    </div>
  );
}
